// register component(s) with react habitat

import HomeSlider from './HomeSlider'

export default {
  HomeSlider,
}
